// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uWjw","delete":"styles_delete__rxeyi","update":"styles_update__WHHer","add":"styles_add__dN337"};